/**
 * Combined Typing Hook
 * 
 * Now simplified to only handle typing detection since WebSocket communication
 * is handled directly in the main ChatRoom handler.
 * 
 * Features:
 * - Typing detection with smart key filtering
 * - Sends typing_start/typing_stop messages via WebSocket
 */

import { useTypingDetector } from './useTypingDetector';
import { isConnected } from '../utils/websocket';

/**
 * Get WebSocket instance for typing messages
 * This function provides access to the current WebSocket connection
 */
const getWebSocketInstance = () => {
  // Access the WebSocket instance exposed by websocket.js
  return (typeof window !== 'undefined' && window.__getWebSocketInstance) 
    ? window.__getWebSocketInstance() 
    : null;
};

/**
 * Main typing hook - now only handles detection and sending
 */
export const useTypingIndicators = (roomId, getWebSocket = getWebSocketInstance) => {
  // Check if WebSocket is connected
  const connected = isConnected();
  
  // Typing detection (sends typing_start/typing_stop)
  const {
    isTyping: isCurrentUserTyping,
    handleKeyDown,
    handleMessageSend,
    sendTypingStop
  } = useTypingDetector(roomId, connected, getWebSocket);
  
  return {
    // For input component
    isCurrentUserTyping,
    handleKeyDown,
    handleMessageSend,
    sendTypingStop,
    
    // Connection status
    connected
  };
};